/**
 * Sets A Custom Document Title
 *
 * @param props - A String Containing The Desired Document Title Name
 * @returns A Function / JSX Hook To Set The Document Title
 */
export const setDocumentTitle = (title: string) => {
  // Setting The Title - if title is empty, just show "Drivn"
  document.title = title ? `Drivn - ${title}` : "Drivn";
};